import React from 'react'
import Box from '@material-ui/core/Box'
import Alert from 'ui/components/alert'
import InputLabel from '@material-ui/core/InputLabel'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconArrowDown } from 'assets/icons/arrow-down.svg'
import useTranslation from 'hooks/useTranslations'
import useStyles from './inputStyles'

const Search = ({ genericError, values, options, setValues }) => {
  const handleLvl1Change = (_, value) => {
    setValues.lvl1(value)
    setValues.lvl2(null)
    setValues.lvl3(null)
  }
  const handleLvl2Change = (_, value) => {
    setValues.lvl2(value)
    setValues.lvl3(null)
  }
  const handleLvl3Change = (_, value) => {
    setValues.lvl3(value)
  }

  const classes = useStyles()
  const t = useTranslation()

  return (
    <>
      {genericError ? (
        <Box mb={2}>
          <Alert severity="error">{t('cpv-selector:error')}</Alert>
        </Box>
      ) : null}
      <Box mb={2}>
        <InputLabel htmlFor="level-01" shrink>
          {t('cpv-selector:level1')}
        </InputLabel>
        <Autocomplete
          id="level-01"
          className={`${values.lvl1 ? classes.hasValue : ''}`}
          value={values.lvl1}
          fullWidth
          popupIcon={<SvgIcon component={IconArrowDown} />}
          onChange={handleLvl1Change}
          getOptionLabel={option => option.name || ''}
          getOptionSelected={(option, value) => option.name === value.name}
          options={options.lvl1}
          selectOnFocus
          renderInput={params => (
            <TextField
              {...params}
              placeholder={t('cpv-selector:placeholder')}
              variant="outlined"
            />
          )}
        />
      </Box>
      <Box mb={2}>
        <InputLabel htmlFor="level-02" shrink>
          {t('cpv-selector:level2')}
        </InputLabel>
        <Autocomplete
          mb={2}
          id="level-02"
          className={`${values.lvl2 ? classes.hasValue : ''}`}
          value={values.lvl2}
          fullWidth
          popupIcon={<SvgIcon component={IconArrowDown} />}
          onChange={handleLvl2Change}
          getOptionLabel={option => option.name || ''}
          getOptionSelected={(option, value) => option.name === value.name}
          options={options.lvl2}
          disabled={!options.lvl2.length}
          selectOnFocus
          renderInput={params => (
            <TextField
              {...params}
              placeholder={t('cpv-selector:placeholder')}
              variant="outlined"
            />
          )}
        />
      </Box>
      <Box mb={2}>
        <InputLabel htmlFor="level-03" shrink>
          {t('cpv-selector:level3')}
        </InputLabel>
        <Autocomplete
          id="level-03"
          className={`${values.lvl3 ? classes.hasValue : ''}`}
          value={values.lvl3}
          fullWidth
          popupIcon={<SvgIcon component={IconArrowDown} />}
          onChange={handleLvl3Change}
          getOptionLabel={option => option.name || ''}
          getOptionSelected={(option, value) => option.name === value.name}
          options={options.lvl3}
          disabled={!options.lvl3.length}
          selectOnFocus
          renderInput={params => (
            <TextField
              {...params}
              placeholder={t('cpv-selector:placeholder')}
              variant="outlined"
            />
          )}
        />
      </Box>
    </>
  )
}
export default Search
